import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-dark text-light pt-4">
      <div className="container">
        <div className="row">
          {/* About Section */}
          <div className="col-md-4 mb-3">
            <h5>
              JomFreeCredit | FreeCredit Malaysia | FreeKredit No Deposit Bonus
            </h5>
            <p>
              We provide the latest <strong>free credit</strong> and{" "}
              <strong>freekredit</strong>
              <span> </span>
              offers in Malaysia, including no deposit bonuses for new players.
              Discover trusted gaming promotions, slot updates, and daily
              rewards.
            </p>
            <p>
              Explore popular platforms like Mega888, 918Kiss, and Pussy888 with
              free credit promotions such as RM50 new member bonuses, 365 hari
              cuci, and other exclusive deals.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-4 mb-3">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li>
                <Link to="/" className="text-light text-decoration-none">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/" className="text-light text-decoration-none">
                  Free Credit List
                </Link>
              </li>
              <li>
                <Link to="/aboutus" className="text-light text-decoration-none">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-md-4 mb-3">
            <h5>Follow Us</h5>
            <div className="d-flex gap-3">
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-facebook"></i>
              </a>
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-instagram"></i>
              </a>
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-linkedin"></i>
              </a>
              <a as={Link} to="/" className="text-light fs-4">
                <i className="bi bi-youtube"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center py-3 border-top mt-3">
          &copy; {new Date().getFullYear()} Jom Free Credit. All rights
          reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
